/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Features_TitleInputs */

const en_home_features_title = /** @type {(inputs: Home_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything you expect from a 2D drafting tool`)
};

/**
* | output |
* | --- |
* | "Everything you expect from a 2D drafting tool" |
*
* @param {Home_Features_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_features_title = /** @type {((inputs?: Home_Features_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Features_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_features_title(inputs)
});
export { home_features_title as "home.features.title" }